import { get_axios_instance, api_variables,get_axios_file_instance, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_EMP_EXITS);
var axios_instance_non_resignee_search_employees = get_axios_instance(api_variables.SERVICE_SEARCH_EMP_NON_EXITS);
var axios_instance_resignee_filter_employees = get_axios_instance(api_variables.SERVICE_FILTER_EMP_EXITS); 
var axios_instance_upload_template = get_axios_file_instance(api_variables.SERVICE_EMP_EXITS_UPLOAD_TEMPLATE);


const _pk_name = "id";

const state = {
    data: [],
    exits: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    setExits: (state, payload) => {
        if (payload) {
            state.exits = payload;
        }
    },

    addEmployee: (state, payload) => {
        state.exits = payload;
    },

    //   updateEmployeeById: (state, payload) => {
    //     for(let i=0; i<state.data.length; i++) {
    //       if(state.data[i][_pk_name] === payload.id) {
    //         state.data.splice(i, 1, payload);
    //       }
    //     }
    //   },

    // removeEmployeeById: (state, payload) => {
    //     for (let i = 0; i < state.data.length; i++) {
    //         if (state.data[i][_pk_name] == payload) {
    //             state.data.splice(i, 1);
    //         }
    //     }
    // },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {

    async uploadTemplate({ commit }, payload) {
        try {
            // commit("setFetching", true);
            let res = await axios_instance_upload_template.post(``,payload);
            // commit("setFetching", false);
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async fetchExits({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("setExits", res.data.rows);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async fetchLegalEntityNonExitsEmployeeSearchList({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_non_resignee_search_employees.get(`/`, {
                params: {
                    key: payload.key,
                    le_id: payload.le_id
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("setExits", res.data.rows);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async fetchLegalEntityNonExitsEmployeeFilterList({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_resignee_filter_employees.post(`/`, payload);
            commit("setFetching", false);
            if (res.status == 200) {
                commit("setExits", res.data.rows);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addEmployee", payload);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    // async update({ commit }, payload) {
    //     //console.log("[state/payroll/add_exit_employees/update] Updating... Display payload", payload);
    //     try {
    //         commit("setSaving", true);
    //         let res = await axios_instance.put(`/${payload.id}`, payload);
    //         commit("setSaving", false);
    //         //console.log("[state/payroll/add_exit_employees/update] res: ", res);
    //         if (res.status == 200) {
    //             commit("updateEmployeeById", res.data);
    //         }
    //         return res;
    //     } catch(err) {
    //         //console.log('err:',err.response);
    //         throw errorHandler(err.response);
    //       }
    // }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}